var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.enableChat
    ? _c(
        "el-upload",
        {
          staticClass: "picUpload",
          attrs: {
            action: _vm.avatarUploadUrl,
            headers: _vm.myHeaders,
            "on-success": _vm.uploadSuccess,
            "before-upload": _vm.beforeUpload,
            "show-file-list": false,
            accept: "image/png, image/jpeg, image/jpg",
          },
        },
        [
          _c(
            "el-tooltip",
            {
              attrs: { content: "发送图片", placement: "top", effect: "light" },
            },
            [_c("span", { staticClass: "picIcon" })]
          ),
        ],
        1
      )
    : _c("span", { staticClass: "picIcon" })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--1!./node_modules/vue-loader/lib??vue-loader-options!./src/views/classroom1/components/picUpload.vue?vue&type=template&id=18ac34f9&scoped=true&
// module id = null
// module chunks = 